import { z } from 'zod';

export const CJPromoShelfEpisode = z.object({
  id: z.number(),
  title: z.string(),
  number: z.number(),
  coverImageUrl: z.string(),
  videoUrl: z.string(),
  subtitlesUrl: z.string().nullish().optional(),
});
export type CJPromoShelfEpisode = z.infer<typeof CJPromoShelfEpisode>;

export const CJPromoShelfSeries = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  coverImageUrl: z.string(),
  deepLink: z.string(),
  episodes: z.array(CJPromoShelfEpisode),
});
export type CJPromoShelfSeries = z.infer<typeof CJPromoShelfSeries>;

export const CJPromoShelf = CJPromoShelfSeries.array();
export type CJPromoShelf = z.infer<typeof CJPromoShelf>;
